import { API, API_GET } from "../../../Config"


export const GetChallenges = () => {
  return (
    API_GET(API.GetChallenges)
  )
}

